import { HtmlContent } from '@mediahuis/chameleon-react'
import React, { useEffect, useState } from 'react'

import { patchAccountConsent } from '../../../api'
import { Consent } from '../../../api/AccountConsent/getAccountConsents'
import { Purpose, getPurposeCopy } from '../../../api/AccountConsent/getPurposeCopy'
import { getBrand } from '../../../core/pure/Env'
import { MoreInfoText } from './MoreInfoText'

export interface CheckboxConsent extends Consent {
  status: 'Accepted' | 'Declined'
}

type ConsentCheckboxProps = {
  consent: CheckboxConsent
  accountId: string
}

export const ConsentCheckbox: React.FC<ConsentCheckboxProps> = ({ consent, accountId }) => {
  const shouldBeChecked = () => {
    switch (consent.status) {
      case 'Accepted':
        return true
      case 'Declined':
        return false
      default:
        return false
    }
  }

  const [isChecked, setIsChecked] = useState<boolean>(shouldBeChecked())
  const [purpose, setPurpose] = useState<Purpose | null>(null)

  const formatHeader = (text: string | undefined) => {
    if (text) {
      if (getBrand() === 'dl') {
        return (
          <HtmlContent>
            <div dangerouslySetInnerHTML={{ __html: text }}></div>
          </HtmlContent>
        )
      }
      return text
    }
    return null
  }

  const formatBody = (purpose: Purpose | null) => {
    if (purpose?.settingsCheckboxText) {
      if (getBrand() === 'dl') {
        return (
          <HtmlContent style={{ marginTop: '-25px', marginLeft: '25px' }}>
            <div dangerouslySetInnerHTML={{ __html: purpose.settingsCheckboxText }}></div>
          </HtmlContent>
        )
      }
      return purpose.settingsCheckboxText
    }
    return ''
  }

  useEffect(() => {
    ;(async () => {
      setPurpose(await getPurposeCopy())
    })()
  }, [])

  return (
    <>
      <div style={headerStyle}>{formatHeader(purpose?.settingsText)}</div>
      <label>
        <input
          id={`consent-checkbox-${consent.id}`}
          name={`consent-checkbox-${consent.id}`}
          type="checkbox"
          onChange={async () => {
            setIsChecked(!isChecked)
            await patchAccountConsent(accountId, {
              isAccepted: !isChecked,
              version: consent.version,
            })
          }}
          aria-label="Ads and data"
          checked={isChecked}
        />
        <span style={{ marginLeft: '5px' }}>{formatBody(purpose)}</span>
      </label>
      <div style={footerStyle}>
        <MoreInfoText html={String(purpose?.settingsExtraInfoText)} />
      </div>
    </>
  )
}

const headerStyle = {
  marginBottom: '15px',
}

const footerStyle = {
  marginTop: '15px',
}
